import { ADD_DEFAULT_TEXT } from '../../action-types/bookproperties/index';

export const STATE_KEY = 'defaultText';

export const defaultText = (state = '', action) => {
  switch (action.type) {
    case ADD_DEFAULT_TEXT: {
      return action.text;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/defaultText.js